module.exports = __webpack_public_path__ + "static/Recruit04_01-63ad887dbea3d5dfbf75673038bef6e3.png";